__turbopack_context__.v({
  "active": "_26zvCq_active",
  "chevron-icon": "_26zvCq_chevron-icon",
  "child-item": "_26zvCq_child-item",
  "childrenSubmenu": "_26zvCq_childrenSubmenu",
  "clickLinks": "_26zvCq_clickLinks",
  "dactive": "_26zvCq_dactive",
  "dpactive": "_26zvCq_dpactive",
  "dropdown-submenu": "_26zvCq_dropdown-submenu",
  "dropdown-toggle": "_26zvCq_dropdown-toggle",
  "dropdownLinkContainer": "_26zvCq_dropdownLinkContainer",
  "dropdownToggle": "_26zvCq_dropdownToggle",
  "has-children": "_26zvCq_has-children",
  "hideSubMenu": "_26zvCq_hideSubMenu",
  "menuIcon": "_26zvCq_menuIcon",
  "menuList": "_26zvCq_menuList",
  "parentLink": "_26zvCq_parentLink",
  "sectionHeader": "_26zvCq_sectionHeader",
  "subMenu": "_26zvCq_subMenu",
});
